<div class="export-csv">
  <button (click)="openCSVSelectionDialog()" data-action="clicked-export-csv-on-pipeline-table-view" mat-stroked-button>
    {{ 'FRONTEND.SALES_UI.PIPELINE.EXPORT_AS_CSV' | translate }}
  </button>
</div>
